import { render, staticRenderFns } from "./PaymentTotemDetails.vue?vue&type=template&id=48ca08cc"
import script from "./PaymentTotemDetails.vue?vue&type=script&lang=js"
export * from "./PaymentTotemDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentTotemDetails.vue?vue&type=style&index=0&id=48ca08cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports